import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Body from "./components/Body";
import FullPost from "./components/post/FullPost";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="min-h-screen flex flex-col">
          <Header />
          <div className="flex-grow bg-[#161616]">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <Routes>
                <Route index element={<Body />} />
                <Route path="/:buttonUrl" element={<FullPost />} />
              </Routes>
            </div>
          </div>
          <div className="bg-[#000000]">
            <Footer />
          </div>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
